exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lar_input[data-v-468ba0da] {\n  color: black;\n}", ""]);

// exports
